import { COLOR_NEUTRAL_EIGHT, COLOR_NEUTRAL_THREE } from '@myre/common-styles';
import { TagType } from '@myre/common-tag';

import { InjectionToken } from '@angular/core';

export interface InputTagConfig {
  readonly type: TagType;
  readonly textColor: string;
  readonly backgroundColor: string;
}

export const INPUT_TAG_CONFIG = new InjectionToken<InputTagConfig>(
  'input-tag-config',
  {
    providedIn: 'root',
    factory: () => ({
      type: TagType.Custom,
      textColor: COLOR_NEUTRAL_EIGHT,
      backgroundColor: COLOR_NEUTRAL_THREE,
    }),
  },
);
